import { getCookie, removeCookie } from '@analytics/cookie-utils';
import { Login } from '@types';
import { deleteCookie } from '@utils';
import { axiosInstance } from './axios-instance';

export class AuthService {
    static init(companyName: string) {
        return new AuthService(companyName);
    }
    ssoTokenKey = 'df_token';

    constructor(private companyName: string) {}

    setHeaders(token: string) {
        axiosInstance.defaults.headers['Authorization'] = `Token ${token}`;
    }

    // requests
    obtainAnonymousToken() {
        return axiosInstance
            .post<{ token: string }>('/v2/obtain_anonymous_auth_token/', {
                company_name: this.companyName,
            })
            .then(response => {
                const token = response.data.token;
                this.setHeaders(token);
                return response;
            });
    }

    obtainAuthToken(login: Login) {
        return axiosInstance
            .post<{ token: string }>('/v2/obtain_auth_token/', {
                company_name: this.companyName,
                ...login,
            })
            .then(response => {
                const token = response.data.token;
                this.setHeaders(token);
                return response;
            });
    }

    obtainSessionToken() {
        return axiosInstance
            .post<{ token: string }>('/v2/obtain_session_token/', null, { maxRedirects: 0, withCredentials: true })
            .then(response => {
                const token = response.data.token;
                this.setHeaders(token);
                return response;
            });
    }

    logout() {
        return axiosInstance.post('/v2/logout/', undefined, { withCredentials: true });
    }

    // sso
    getSsoToken(): string {
        const [_, token] = getCookie(this.ssoTokenKey).split(':');
        return token;
    }
    clearSsoToken() {
        removeCookie(this.ssoTokenKey); // does not work with different domain
        // deleteCookie(this.ssoTokenKey, '/', '.test-boris.digifabster.com'); // work with concrete domain
    }
}
